import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

export interface GetParametroTextoRequest {
  nombre: string;
}

export const getParametroTexto = async (data: GetParametroTextoRequest) => {
  try {
    const res = await apiClient.post(Endpoints.GetParametroTexto, data);
    return res.data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
